module.exports = __webpack_public_path__ + "static/don32-80c6e28c26e58f02f099a92bd70f6d8c.jpg";